import { render, staticRenderFns } from "./RegistrationConfirm.modal.vue?vue&type=template&id=4eda22e8&scoped=true&lang=pug&"
import script from "./RegistrationConfirm.modal.vue?vue&type=script&lang=ts&"
export * from "./RegistrationConfirm.modal.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationConfirm.modal.vue?vue&type=style&index=0&id=4eda22e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eda22e8",
  null
  
)

export default component.exports